// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#upload {
  opacity: 0;
}

#upload-label {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
}

.image-area {
  border: 2px dashed black;
  padding: 1rem;
  position: relative;
}

.image-area::before {
  content: "l'image téléchargée";
  color: black ;
  font-weight: bold;
  text-transform: uppercase;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.8rem;
  z-index: 1;
}

.image-area img {
  z-index: 2;
  position: relative;
}

/* AddProduct page */
.add-product-section {
  font-weight: 700;
  color: #14532d;
  border-bottom: 1px solid #e3e8e5;
  padding-bottom: 8px;
  margin: 22px 0 16px;
}
.add-product-section:first-child { margin-top: 0; }
.add-product-option {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 10px;
  padding: 2px 10px 2px 2px;
  border: 1px solid #dfe5e1;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: border-color 0.15s, background 0.15s;
}
.add-product-option:hover { border-color: #14532d; }
.add-product-option.is-checked {
  border-color: #14532d;
  background: rgba(20, 83, 45, 0.07);
}
.add-product-card > .card-header {
  background-color: #14532d;
  color: #fff;
}

.add-product-hint { color: #6b7a72; font-size: 0.9rem; margin: -6px 0 12px; }
.add-product-margin { font-size: 0.9rem; padding: 8px 12px; }
.add-product-summary {
  margin-top: 22px;
  padding: 12px 16px;
  border: 1px solid #cfe3d6;
  border-radius: 8px;
  background: rgba(20, 83, 45, 0.05);
}
.add-product-summary ol { margin: 6px 0 0; padding-left: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/productManagement/AddProductStyle.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,mCAAmC,aAAa,EAAE;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;AACA,4BAA4B,qBAAqB,EAAE;AACnD;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oBAAoB,cAAc,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC5E,sBAAsB,iBAAiB,EAAE,iBAAiB,EAAE;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;AACA,0BAA0B,eAAe,EAAE,kBAAkB,EAAE","sourcesContent":["#upload {\n  opacity: 0;\n}\n\n#upload-label {\n  position: absolute;\n  top: 50%;\n  left: 1rem;\n  transform: translateY(-50%);\n}\n\n.image-area {\n  border: 2px dashed black;\n  padding: 1rem;\n  position: relative;\n}\n\n.image-area::before {\n  content: \"l'image téléchargée\";\n  color: black ;\n  font-weight: bold;\n  text-transform: uppercase;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 0.8rem;\n  z-index: 1;\n}\n\n.image-area img {\n  z-index: 2;\n  position: relative;\n}\n\n/* AddProduct page */\n.add-product-section {\n  font-weight: 700;\n  color: #14532d;\n  border-bottom: 1px solid #e3e8e5;\n  padding-bottom: 8px;\n  margin: 22px 0 16px;\n}\n.add-product-section:first-child { margin-top: 0; }\n.add-product-option {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0 0 10px;\n  padding: 2px 10px 2px 2px;\n  border: 1px solid #dfe5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: border-color 0.15s, background 0.15s;\n}\n.add-product-option:hover { border-color: #14532d; }\n.add-product-option.is-checked {\n  border-color: #14532d;\n  background: rgba(20, 83, 45, 0.07);\n}\n.add-product-card > .card-header {\n  background-color: #14532d;\n  color: #fff;\n}\n\n.add-product-hint { color: #6b7a72; font-size: 0.9rem; margin: -6px 0 12px; }\n.add-product-margin { font-size: 0.9rem; padding: 8px 12px; }\n.add-product-summary {\n  margin-top: 22px;\n  padding: 12px 16px;\n  border: 1px solid #cfe3d6;\n  border-radius: 8px;\n  background: rgba(20, 83, 45, 0.05);\n}\n.add-product-summary ol { margin: 6px 0 0; padding-left: 20px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
